/* global Swiper */
/*
 * Swiper for customer case study company info box
 */
(function () {
	"use strict";

	new Swiper (".q-story-carousel", {
		loop: true,
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
		spaceBetween: 30,
		slidesPerView: 4,
		autoHeight: false,
		pagination: {
			el: ".q-story-carousel .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
		breakpoints: {
			240: {
				slidesPerView: 1
			},
			720: {
				slidesPerView: 2
			},
			1180: {
				slidesPerView: 3
			},
			1440: {
				spaceBetween: 50
			},
			1800: {
				slidesPerView: 4
			}
		}
	});

}());